let EVENT_CREATOR_EVENT_DOWN = 'mousedown';
let EVENT_CREATOR_EVENT_UP = 'mouseup';
let EVENT_CREATOR_EVENT_MOVE = 'mousemove';
// Overwrite for MS touch support
if (typeof window !== 'undefined') {
    if (window.PointerEvent) {
        EVENT_CREATOR_EVENT_DOWN = 'pointerdown';
        EVENT_CREATOR_EVENT_UP = 'pointerup';
        EVENT_CREATOR_EVENT_MOVE = 'pointermove';
    }
    else if (window.navigator.msPointerEnabled) {
        EVENT_CREATOR_EVENT_DOWN = 'MSPointerDown';
        EVENT_CREATOR_EVENT_UP = 'MSPointerUp';
        EVENT_CREATOR_EVENT_MOVE = 'MSPointerMove';
    }
}
export const CREATOR_EVENT_DOWN = EVENT_CREATOR_EVENT_DOWN;
export const CREATOR_EVENT_UP = EVENT_CREATOR_EVENT_UP;
export const CREATOR_EVENT_MOVE = EVENT_CREATOR_EVENT_MOVE;
export const CREATOR_EVENT_LEAVE = 'mouseleave';
export const CREATOR_EVENT_OUT = 'mouseout';
export const CREATOR_EVENT_CLICK = 'click';
export const CREATOR_EVENT_TOUCHSTART = 'touchstart';
export const CREATOR_EVENT_TOUCHMOVE = 'touchmove';
export const CREATOR_EVENT_TOUCHEND = 'touchend';
export const CREATOR_EVENT_TOUCHCANCEL = 'touchcancel';
//# sourceMappingURL=AnnotationCreator.js.map